import { tns } from 'tiny-slider'

export default function() {
	const els = [...document.querySelectorAll('.carousel')]
	els.map(el => {
	    const slider = tns({
	        container: el,
			slideBy: 1,
			autoplay: true,
			controls: false,
			nav: false,
			mouseDrag: true,
			autoplayButton: false,
			autoplayButtonOutput: false,
			speed: 700,
			fixedWidth: 250,
			autoplayTimeout: 3000,
			edgePadding : 0,
			gutter: 20,
			center: true,
			responsive : {
				0 : { fixedWidth: 130, },
				400 : { fixedWidth: 170, },
				800 : { fixedWidth: 200, },
				1100 : { fixedWidth: 250, },
			}
	    })
	})
}